module.exports = __webpack_public_path__ + "assets/img/laborUnion.c8131ebd.png";